import { Field } from 'formik';
import { useIntl } from 'react-intl';
import { FieldProps } from '../../types/fields';
import validatePassword from '../../utils/validatePassword';
import getValidator from '../../utils/getValidator';
import TextField from '../formik/TextField';

type PasswordFieldProps = FieldProps & { type: 'signIn' | 'register' | 'passwordReset' };

const PasswordField = (props: PasswordFieldProps) => {
  const { formatMessage } = useIntl();

  return (
    <Field
      name={[props.context, 'password'].filter(Boolean).join('.')}
      component={TextField}
      label={formatMessage({
        id:
          props.type === 'passwordReset'
            ? 'auth.embedded.newPassword'
            : props.type === 'register'
            ? 'auth.options.register.password'
            : 'generic.password',
      })}
      type="password"
      validate={props.type !== 'signIn' ? validatePassword : getValidator({ required: true })}
      data-test-id={`${props.testIdPrefix}-password`}
      isInputStatusIconDisabled={props.type === 'signIn'}
    />
  );
};

export default PasswordField;
